/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DomainsControllerRemoveMutationResponse, DomainsControllerRemovePathParams, DomainsControllerRemove401, DomainsControllerRemove403, DomainsControllerRemove404 } from "../../models/domainsController/DomainsControllerRemove";

function getDomainsControllerRemoveUrl(id: DomainsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/domains/${id}` as const }  
  return res
}

/**
 * @summary Delete a domain
 * {@link /api/v1/domains/:id}
 */
export async function domainsControllerRemove(id: DomainsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DomainsControllerRemoveMutationResponse, ResponseErrorConfig<DomainsControllerRemove401 | DomainsControllerRemove403 | DomainsControllerRemove404>, unknown>({ method : "DELETE", url : getDomainsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}